import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// utils
import { ellipsis } from 'polished'

const Wrapper = styled.form`
  margin: 16px;
`

const EndPointWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  p {
    color: ${colors.gray300};
    margin: 0;
    font-size: 12px;
  }
`

const EndPointName = styled.span`
  background-color: ${colors.gray210};

  ${ellipsis('100%')};
`

const LinkToCopy = styled.span`
  color: ${colors.blue500};
  cursor: pointer;
`

const ParametersWrapper = styled.div`
  margin-top: 10px;

  p {
    margin-top: 0;

    &:first-child {
      margin-bottom: 10px;
      font-size: 18px;
    }
  }

  > div:not(:last-child) {
    border-bottom: none;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.gray300};
  padding: 10px;
`

const Title = styled.span`
  font-weight: bold;
`

export { Wrapper, EndPointWrapper, EndPointName, LinkToCopy, ParametersWrapper, Row, Title }
